const pagination = {
  perPage: 10,
  currentPage: 1,
  total: 0,
  perPageOptions: [5, 10, 20, 25, 50],
};

const functions = {
  pagedData() {
    return this.tdata.slice(this.from, this.to);
  },
  queriedData() {
    let result = this.tdata;
    this.pagination.total = result.length;

    return result.slice(this.from, this.to);
  },
  to() {
    let highBound = this.from + this.pagination.perPage;
    if (this.total < highBound) {
      highBound = this.total;
    }

    return highBound;
  },
  from() {
    return this.pagination.perPage * (this.pagination.currentPage - 1);
  },
  total() {
    return this.tdata.length;
  },
};

export default { pagination, functions };
